import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McDropdownLegacy, McInputNew, McTextAreaNew } from "../../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";
import {
  FUNKSJONSKONTROLL_LAFTAK_TESTER_METODER,
  FunksjonskontrollLAFTakTesterEnum,
} from "../../../../../../../mc-shared/gkReportConstants";
import {
  IGKFunksjonskontrollLAFTakResultater,
  IGKRapport,
} from "../../../../../../../mc-shared/reportSchemas/gkReportSchema";
const FunksjonskontrollLAFTak: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKFunksjonskontrollLAFTakResultater;
}> = ({ data, onUpdateEditData }) => {
  const addOrRemoveTest = (test: FunksjonskontrollLAFTakTesterEnum) => {
    data.inndata.valgtMetode[test] = !data.inndata.valgtMetode[test];
    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.valgtMetode", data.inndata.valgtMetode);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Funksjonskontroll av LAF-tak</Title>
        <b>Velg hvilke tester som skal utføres?</b>
        <div className="w-25 mb-4">
          <McDropdownLegacy
            filterOptions={FUNKSJONSKONTROLL_LAFTAK_TESTER_METODER.map((test) => {
              return {
                ...test,
                isActive: data.inndata.valgtMetode[test.value],
              };
            })}
            onClick={(value) => addOrRemoveTest(value)}
            title="Velg tester"
            color="secondary"
            textColor="text-black"
          />
        </div>
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.KONTROLLAVBETJENINGSPANEL] === true && (
          <>
            <h4>Kontroll av betjeningspanel</h4>
            <div>
              <h5 className="mb-0 mt-2">På/av-knapp</h5>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.paaAvKnappGodkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.kontrollAvBetjeningspanelResultater.paaAvKnappGodkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.paaAvKnappGodkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.kontrollAvBetjeningspanelResultater.paaAvKnappGodkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div>
              <h5 className="mb-0 mt-2">Flow-knapp</h5>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.flowKnappGodkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.kontrollAvBetjeningspanelResultater.flowKnappGodkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.flowKnappGodkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.kontrollAvBetjeningspanelResultater.flowKnappGodkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div>
              <h5 className="mb-0 mt-2">Lys-knapp</h5>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.lysKnappGodkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.kontrollAvBetjeningspanelResultater.lysKnappGodkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.kontrollAvBetjeningspanelResultater.lysKnappGodkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.kontrollAvBetjeningspanelResultater.lysKnappGodkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.kontrollAvBetjeningspanelResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.kontrollAvBetjeningspanelResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.LYSPAERER] === true && (
          <>
            <h4>Visuell kontroll av lyspærer/lysrør frontpanel</h4>
            <div>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.lyspaererResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.lyspaererResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.lyspaererResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.lyspaererResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lyspaererResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.lyspaererResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.DISPLAY] === true && (
          <>
            <h4>Visuell kontroll av display</h4>
            <div>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.displayResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.displayResultater.godkjent", true)
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.displayResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.displayResultater.godkjent", false)
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.displayResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.displayResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.SKADER] === true && (
          <>
            <h4>Visuell kontroll av skader</h4>
            <div>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.skaderResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.skaderResultater.godkjent", true)
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.skaderResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.skaderResultater.godkjent", false)
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.skaderResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.skaderResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.LEKKASJE] === true && (
          <>
            <h4>Visuell kontroll av lekkasje</h4>
            <div>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.lekkasjeResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.lekkasjeResultater.godkjent", true)
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.lekkasjeResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.lekkasjeResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lekkasjeResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.lekkasjeResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.POSISJON] === true && (
          <>
            <h4>Visuell kontroll av posisjon</h4>
            <div>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.posisjonResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.posisjonResultater.godkjent", true)
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.posisjonResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.posisjonResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.posisjonResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.posisjonResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.LYD] === true && (
          <>
            <h4>Kontroll av lyd/støy</h4>
            <div>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.lydResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.lydResultater.godkjent", true)
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.lydResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData("testResultater.funksjonskontrollLAFTak.inndata.lydResultater.godkjent", false)
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lydResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.lydResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollLAFTakTesterEnum.FORFILTER] === true && (
          <>
            <h4>Visuell kontroll av forfilter</h4>
            <div>
              <div className="d-flex flex-column">
                <Radio
                  checked={data.inndata.forfilterResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.forfilterResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.forfilterResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollLAFTak.inndata.forfilterResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.forfilterResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollLAFTak.inndata.forfilterResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
      </Stack>
    </Paper>
  );
};
export default FunksjonskontrollLAFTak;
